<script setup lang="ts">
import type { ImprintItem, ProfileItem } from '../navigation-bar';
import Divider from '../../Divider/Divider.vue';

const props = defineProps<{
  profileItems: ProfileItem[];
  imprintItems: ImprintItem[];
}>();

const emits = defineEmits<{
  navigateTo: [href: string];
}>();
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <Divider class="mb-2 w-full">
      <div
        v-for="item in props.profileItems"
        :key="item.id"
        class="w-full cursor-pointer rounded-md p-2 text-center text-sm hover:bg-neutral-50"
        :class="[item.isLogout && 'text-danger-500']"
        @click="emits('navigateTo', item.href)"
      >
        {{ item.label }}
      </div>
    </Divider>

    <div class="flex max-w-[200px] flex-wrap items-center justify-center gap-2">
      <div
        v-for="item in props.imprintItems"
        :key="item.id"
        class="text-xs text-neutral-500"
        :class="[item.href && 'cursor-pointer hover:underline']"
        @click="() => item.href && emits('navigateTo', item.href)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
